import { FillType } from '~/static/enums/components/color-input'
import { ObjectType } from '~/static/enums/object-type'
import { VersionMigrator } from '~/utils/editor/versioning/migrators'
import { ObjectPropsV1, ObjectPropsV2, migrate as migrateObject } from '~/utils/editor/versioning/object'

export enum Versions {
  V1 = 1, // data has no field 'version'
  V2 = 2,
}

export const ActualVersionNumber = Versions.V2
export type ActualVersion = SvgFigurePropsV2

export interface SvgFigurePropsV1 extends ObjectPropsV1 {
  type?: ObjectType.SvgFigure

  width?: number
  height?: number
  borderRadius?: number
  hasBackground?: boolean
  colorType?: FillType
  color?: FabricGradientOptions | string
  opacity?: number
  border?: number
  borderColor?: string
  borderOpacity?: number
  borderDash?: boolean
  borderExists?: boolean
  shadow?: boolean
  shadowColor?: string
  shadowOpacity?: number
  shadowX?: number
  shadowY?: number
  shadowBlur?: number
  figureIndex?: number
}

export interface SvgFigurePropsV2 extends ObjectPropsV2 {
  type?: ObjectType.SvgFigure

  width?: number
  height?: number
  borderRadius?: number
  hasBackground?: boolean
  colorType?: FillType
  color?: FabricGradientOptions | string
  opacity?: number
  border?: number
  borderColor?: string
  borderOpacity?: number
  borderDash?: boolean
  borderExists?: boolean
  shadow?: boolean
  shadowColor?: string
  shadowOpacity?: number
  shadowX?: number
  shadowY?: number
  shadowBlur?: number
  figureIndex?: number
}

export const migrate: VersionMigrator<SvgFigurePropsV2> = (data: object) => {
  if ('version' in data && data.version === Versions.V2) {
    return data as SvgFigurePropsV2
  }

  const dataV1 = data as SvgFigurePropsV1

  return {
    type: ObjectType.SvgFigure,  
    ...migrateObject(dataV1),
    version: Versions.V2,
    title: 'Фигура',
    width: dataV1.width,
    height: dataV1.height,
    borderRadius: dataV1.borderRadius,
    hasBackground: dataV1.hasBackground,
    colorType: dataV1.colorType,
    color: dataV1.color,
    opacity: dataV1.opacity,
    border: dataV1.border,
    borderColor: dataV1.borderColor,
    borderOpacity: dataV1.borderOpacity,
    borderDash: dataV1.borderDash,
    borderExists: dataV1.borderExists,
    shadow: dataV1.shadow,
    shadowColor: dataV1.shadowColor,
    shadowOpacity: dataV1.shadowOpacity,
    shadowX: dataV1.shadowX,
    shadowY: dataV1.shadowY,
    shadowBlur: dataV1.shadowBlur,
    figureIndex: dataV1.figureIndex,
  } as SvgFigurePropsV2
}
